import React from 'react';

const Hero: React.FC = () => {
  return (
    <section className="hidden md:block relative h-screen">
      <div className="grid grid-cols-1 md:grid-cols-2 h-full">
        {/* Restaurant Half */}
        <div className="relative bg-primary-black flex items-center justify-center overflow-hidden group">
          <div 
            className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
            style={{
              backgroundImage: "url('/images/restaurant/full-dining-room.webp')",
            }}
          ></div>
          <div className="absolute inset-0 bg-primary-black opacity-80"></div>
          <div className="relative z-10 text-center px-8">
            <h2 className="text-3xl md:text-6xl font-bold mb-3 md:mb-6 text-primary-gold font-display">
              Restaurant
            </h2>
            <p className="text-sm md:text-xl mb-4 md:mb-8 max-w-md mx-auto text-white">
              Fine dining experience with locally sourced ingredients and expertly crafted dishes
            </p>
            <a 
              href="/restaurant" 
              className="bg-primary-gold text-primary-black px-6 md:px-8 py-2 md:py-3 rounded-full font-semibold text-sm md:text-base hover:bg-primary-black hover:text-primary-gold hover:border-2 hover:border-primary-gold transition-all"
              aria-label="View restaurant menu and dining options"
            >
              View Menu
            </a>
          </div>
        </div>

        {/* Snooker Hall Half */}
        <div className="relative bg-primary-black flex items-center justify-center overflow-hidden group">
          <div 
            className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
            style={{
              backgroundImage: "url('/images/snooker/snooker-player-aiming.webp')",
            }}
          ></div>
          <div className="absolute inset-0 bg-primary-black opacity-80"></div>
          <div className="relative z-10 text-center px-8">
            <h2 className="text-3xl md:text-6xl font-bold mb-3 md:mb-6 text-primary-gold font-display">
              Snooker & Pool Hall
            </h2>
            <p className="text-sm md:text-xl mb-4 md:mb-8 max-w-md mx-auto text-white">
              Premium tables, professional equipment, and the perfect atmosphere for a great game
            </p>
            <a 
              href="/snooker" 
              className="bg-primary-gold text-primary-black px-6 md:px-8 py-2 md:py-3 rounded-full font-semibold text-sm md:text-base hover:bg-primary-black hover:text-primary-gold hover:border-2 hover:border-primary-gold transition-all"
              aria-label="Book a snooker or pool table"
            >
              Book a Table
            </a>
          </div>
        </div>
      </div>

      {/* Divider Line */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20 hidden md:block">
        <div className="bg-primary-gold h-16 w-1 rounded-full shadow-lg"></div>
      </div>
    </section>
  );
};

export default Hero;
